import { MutableRefObject, useCallback, useEffect, useRef, useState } from "react";

export const isCreate = () => {
    return window.location.hash.split("?")[0].split("/")[2] === "create"
};

export const useHash = (): [hash: string, setHash: Function] => {
    const [hash, setHash] = useState(() => window.location.hash);

    const hashChangeHandler = useCallback(() => {
        setHash(window.location.hash);
    }, []);

    useEffect(() => {
        window.addEventListener('hashchange', hashChangeHandler);
        return () => {
            window.removeEventListener('hashchange', hashChangeHandler);
        };
    }, [hashChangeHandler]);

    const updateHash = useCallback(
        newHash => {
            if (newHash !== hash) window.location.hash = newHash;
        },
        [hash]
    );

    return [hash, updateHash];
};

export const useWidth = (): [ref: MutableRefObject<any>, width: number] => {
    const ref = useRef(null);
    const [width, setWidth] = useState();
    const resize = useCallback(() => {
        if (ref && ref.current && ref.current.offsetWidth) {
            setWidth(ref.current.offsetWidth);
        }
    }, []);
    useEffect(() => {
        resize();
        window.addEventListener("resize", resize);
    }, [resize]);
    return [ref, width];
};

export const filterValue = (value) => {
    return {
        format: "hasura-raw-query",
        value
    };
};

export const filterObject = (key, value) => {
    const keys = key.split(".");
    let current = keys.pop();
    while (current !== undefined) {
        let n = {};
        n[current] = value;
        value = n;
        current = keys.pop();
    }
    return value;
};

export const filter = (key: string, valueReceive: any, operator = "_eq") => {
    let value: any = {};
    value[operator] = valueReceive;
    if (key) {
        value = filterObject(key, value);
    }
    return {
        key: valueReceive,
        format: "hasura-raw-query",
        value
    };
};

export const getHas = (permissions) => (permission: string | string[], resource: any) => {
    let hasPermission = false;
    if (typeof permission === "string") {
        hasPermission = permissions.indexOf(permission) >= 0;
    } else {
        for (const p of permission) {
            hasPermission = permissions.indexOf(p) >= 0;
            if (hasPermission) {
                break;
            }
        }
    }
    return hasPermission ? resource : null;
};